// @ts-nocheck
import { isPlatformWeb } from 'renative';
import { iOS } from './api/utils';

const getSoftwareStatement = () => {
    if (isPlatformWeb) {
        // Web SoftwareStatement
        return 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIwMTVjODBlZC04ZDcxLTQ4ZGEtOTZkZi00NzU5NjIwNzJlYTQiLCJuYmYiOjE2NzMzNTg4NDksImlzcyI6ImF1dGguYWRvYmUuY29tIiwiaWF0IjoxNjczMzU4ODQ5fQ.RdCbsIVBHKJPrazBXYYDvoIjTD0OmupwMLjxcUbi1KJyobzczs8Z8xiQOmTHMntiNOAbIFVE2fJzAo_--ceHqTakB5Q-ol95MiiTVyeJjBVgFjjr_SvOtBicVdAUYlIVCwyApAyMUhSiciOyiT9fLtZVrY5MpBVXRZovhVAil4ggIgLYuemNiKC_8smVB0uxH9pLo4CHho19BjCrW9ynomwZmh9Sw_KRjuRnavRg-En6Iu9LGQJ-NA_uY563-bNlZhT7OtIn8WC_ZZHEHmuvO-HVHlaiMtwdovcDA4H4uh_mB2Z4ZajNdH9pGdTOb3MSaSXtzCihz7lpImN8lMUhAA';
    }
    return iOS ? 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIyM2JjYzI3NC1kM2E5LTRmYjYtYjI1OC1iN2RmM2NmYWE4YjkiLCJuYmYiOjE2Njk2MzI1ODksImlzcyI6ImF1dGguYWRvYmUuY29tIiwiaWF0IjoxNjY5NjMyNTg5fQ.fr2q1Q6reOzJbqIg3HQX5rnA3SJMO78L9NJzoEQXdyB3TAqG0eJTJqCfovVtctjj2w2wRS-z7qkrmY_sjCnglaiqA-_Qgg4lGZGazVxSjr_6SEaBys5s_Lz0O9GGAueh1-VeGKgVbjeiNiBXXMKMtrnIsN-MJem9DY88-O4G5P3MyRtahK7_1gMXkzpBSXRo7psKBl_GZAWOIkv8ATqo1CsbWoTio2KVqv7OY-b1PlEF7Qdjyhnjv9m7wQLDjgAlM0LvFRP7DQCx9aHq8wSOxRgJ57wugle8kd7ZBdgYMbLVX7dLOcgD848SBMj0wXTRhcdEKCk_cixDd-sHCDzQ3A' : 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJjM2RhMmM5Mi0xMTBhLTQxMDktYjg1ZS1kNzFlM2I3YzFiYjEiLCJuYmYiOjE2Njk2MzI3MTMsImlzcyI6ImF1dGguYWRvYmUuY29tIiwiaWF0IjoxNjY5NjMyNzEzfQ.HFSWK65h6lMPmLbO22xIr3cxBoxcbuklVjn_9q_lBVDf6ZrfgSyuHmhlhXe1pCp2boHGnIT80DrjhrgDohGpjLxOab5Zeh-6FeOERUnTKVrR-278mWiA5zLK4ranw9FpJzbFBPg4albgh1A1A1f7RNGpaQLSG3OWAQA3JY2GUXhpANg3qt5nDki6LGUkrXS2t9VB6pQoe01Dw9vheLx7b_gZHFwaJ7AWgiz5knIRfxGpQJDKEC6vvtyZwMkIvtTo9SFcZ_-nakGOvj9IfCBFHCto0UT8pR78ym8BsRqeCuEL_CmXT8vLi-7JMOuTq8cUBzGOkQHM-br5OYdltENwPg';
};

const getRedirectUrl = () => {
    if (isPlatformWeb) {
        // Web is a different redirect logic, delivery team needs to provide
        // a landing page or home page redirect url according to customer requirements
        return process.env.WEB_AP_REDIRECT_URL ?? 'https://tas.staging.24imedia.com/home';
    }

    return iOS ? 'adbe.HLzYkv5DRfGveUZKoZmTLA' : 'app.tas.com';
};

export const adobePrimetimeLocalConfig = {
    softwareStatement: getSoftwareStatement(),
    redirectUrl: getRedirectUrl(),
};

export const { softwareStatement, redirectUrl } = adobePrimetimeLocalConfig;

export const ACCESS_ENABLER_CDN_URL =
    'https://entitlement.auth.adobe.com/entitlement/v4/AccessEnabler.js';

export const isLocalConfig = !!softwareStatement.length && !!redirectUrl.length;
